import CXMApiClient from "../../CXMApiClient";

import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {};
}

const state = initialState();

const getters = {};

const actions = {
  getTekionLookup: async function(context, request) {
    let cxmApiClient = new CXMApiClient();
    let resp = await cxmApiClient
      .ProcessRequest("POST", "/api/push_to_dms/v2/lookup", request)
      .catch(function(error) {
        return null;
      });
    return resp && resp.data && resp.data.successful ? resp.data.data : null;
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/DMSPush/TekionPush.js